import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

interface RootProps {
    cursor: "pointer" | "help";
    marginLeft?: number | string;
}

export const Root = styled.div<RootProps>(props => ({
    display: "inline-block",
    userSelect: "none",
    marginLeft: props.marginLeft,
    cursor: props.cursor,
}));

export const IconWrapper = styled.span(props => ({
    color: theme(props).semanticColors.action.color,
}));

export const TooltipContent = styled.div(props => ({
    fontSize: theme(props).typography.primary.fontSize.css(),
    fontFamily: theme(props).typography.fontFamily.regular,
    maxWidth: 240,
    display: "inline-block",
}));
